import { useEffect, useState } from "react"
import actionHelper from "../../lib/actionHelper"
import { uploadBackup } from "../../services/backupApis"
import { API_ROUTES } from "../../utils/constants"

const BackupServer = ({ user }) => {
    const handleFileUpload = (e) => {
        const selectedFile = e.target.files[0]

        actionHelper({
            confirmation: {
                label: "تمام اطلاعات قبلی پاک میشود لطفا قبل از اپلود فایل جدید بکاپ بگیرید",
                actionLabel: "آپلود",
                color: "warning",
            },
            callback: () => uploadBackup(selectedFile, user.token),
            texts: { success: "با موفقیت اپلود شد", pending: "درحال اپلود" },
        })
    }
    if (!user) {
        return
    }

    return (
        <>
            <div className="m-10">
                <div>
                    <input type="file" id="fileInput" onChange={handleFileUpload} style={{ display: "none" }} />
                    <button
                        onClick={() => document.getElementById("fileInput").click()}
                        className="styled-button py-5 text-right w-full"
                    >
                        آپلود بکاپ
                    </button>
                </div>
                <div className="mt-10">
                    <button
                        onClick={() => window.open(`${API_ROUTES.GET_PANEL_BACKUP}?token=${user.token}`)}
                        className="styled-button py-5 text-right w-full"
                    >
                        دانلود بکاپ
                    </button>
                </div>
            </div>
        </>
    )
}

export default BackupServer
